import { Box, Typography } from '@mui/material'
import { ToastKitchenSink } from '../ToastKitchenSink'

export const ToastSection = () => {
  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Toasts
      </Typography>
      <ToastKitchenSink />
    </Box>
  )
}
